module.exports = "/packs/radio-checked-de1f699f6aa3c2b26efaa6a8a5ed451f.svg";